<template>
    <div class="vx-row mt-8">
        <div class="vx-col w-full">
            <span v-for="(fg, index) in linked_formulations_to_dilution" :key="index">
                <div @click.stop="onClickViewFg(fg.id)" class="cursor-pointer text-primary">{{ fg.formulation_code }} -
                    {{ fg.name }}</div>
            </span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'UsedInDilutionFormulationsListTab',
    props: {
        linked_formulations_to_dilution: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onClickViewFg(id) {
            const route = this.$router.resolve({ path: `/pages/formulations/${id}` });
            window.open(route.href, '_blank');
        }
    },
}
</script>
<style lang="">

</style>